import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Draggable from 'react-draggable'
import Paper from '@material-ui/core/Paper'
import classNames from 'classnames'
import DeviceScreenRotation from '@material-ui/icons/ScreenRotation'
import ActionDeleteForever from '@material-ui/icons/DeleteForever'
import EditAction from '@material-ui/icons/Edit'
import AmericanTableIcon from 'components/AmericanTableIcon'
import FrenchTableIcon from 'components/FrenchTableIcon'
import PoolTableIcon from 'components/PoolTableIcon'
import SnookerTableIcon from 'components/SnookerTableIcon'
import ChineseTableIcon from 'components/ChineseTableIcon'
const isOdd = num => num % 2
function getTableIcon(type) {
  let icon
  const style = {
    position: 'absolute',
    top: '2px',
    left: '2px',
    color: 'white'
  }
  switch (type) {
    case 'american':
      icon = <AmericanTableIcon viewBox="5 0 24 24" style={style} />
      break
    case 'pool':
      icon = <PoolTableIcon style={style} />
      break
    case 'snooker':
      icon = <SnookerTableIcon style={style} />
      break
    case 'carom':
      icon = <FrenchTableIcon style={style} />
      break
    case 'chinese':
      icon = <ChineseTableIcon style={style} />
      break
    default:
      icon = null
  }
  return icon
}
const propTypes = {
  classes: PropTypes.object.isRequired,
  table: PropTypes.object.isRequired,
  updateTable: PropTypes.func.isRequired,
  editTable: PropTypes.func.isRequired,
  deleteTable: PropTypes.func.isRequired,
  updateMapSize: PropTypes.func.isRequired,
  toggled: PropTypes.bool.isRequired,
  sizeClass: PropTypes.string.isRequired,
  isSelectable: PropTypes.bool.isRequired,
  selectTable: PropTypes.func.isRequired,
  selectedTable: PropTypes.string.isRequired
}
const styles = {
  american: {
    width: '140px',
    height: '70px',
    lineHeight: '68px'
  },
  chinese: {
    width: '140px',
    height: '70px',
    lineHeight: '68px'
  },
  pool: {
    width: '100px',
    height: '50px',
    lineHeight: '48px'
  },
  snooker: {
    width: '200px',
    height: '100px',
    lineHeight: '98px'
  },
  carom: {
    width: '160px',
    height: '80px',
    lineHeight: '78px'
  }
}
const stylesClasses = theme => ({
  table: {
    position: 'absolute',
    borderRadius: '3px',
    textAlign: 'center',
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: 'white !important',
    userSelect: 'none'
  },
  tableEdit: {
    position: 'absolute',
    borderRadius: '3px',
    textAlign: 'center',
    backgroundColor: `${theme.palette.secondary.dark} !important`,
    color: 'white !important',
    userSelect: 'none'
  }
})
class TableDraggable extends Component {
  componentWillMount = () => {
    this.setState({
      type: 'american',
      selectedTable: this.props.selectedTable,
      isDragging: false,
      isHover: false
    })
  }
  handleSelect = () => {
    if (!(this.props.table.currentTransaction === void 0)) {
      this.props.selectTable(
        this.props.table.name,
        this.props.table.currentTransaction
      )
    }
  }
  handleRotate = () => {
    if (this.props.toggled) {
      this.props.updateTable(this.props.table, {
        isVertical: !this.props.table.isVertical
      })
    }
  }
  handleDrag = (event, ui) => {
    let direction = ''
    if (ui.x === 0) {
      direction = 'left'
    }
    if (ui.x + ui.node.clientWidth >= ui.node.offsetParent.clientWidth) {
      direction = 'right'
    }
    if (ui.y === 0) {
      direction = 'top'
    }
    if (ui.y + ui.node.clientHeight >= ui.node.offsetParent.clientHeight) {
      direction = 'bottom'
    }
    this.setState({ isDragging: true })
    this.props.updateMapSize(direction)
  }
  handleStop = (event, ui) => {
    let x = ui.x - ui.deltaX
    let y = ui.y - ui.deltaY
    switch (this.props.sizeClass) {
      case 'small':
        x *= 2
        y *= 2
        break
      default:
        break
    }
    this.setState({ isDragging: false })
    this.props.updateTable(this.props.table, {
      posX: isOdd(x) ? x + 1 : x,
      posY: isOdd(y) ? y + 1 : y
    })
  }
  handleDelete = () => {
    this.props.deleteTable(this.props.table)
  }
  handleEdit = () => {
    this.props.editTable(this.props.table)
  }
  render() {
    const { table, toggled, classes } = this.props
    const tableActionsStyle = {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    }
    let tableClass = 'table'
    const styleVariant =
      table.type === 'pool'
        ? { width: 20, height: 20, cursor: 'pointer' }
        : { cursor: 'pointer' }
    const tableActions =
      toggled && this.props.sizeClass !== 'small' ? (
        <div style={tableActionsStyle}>
          <DeviceScreenRotation
            color="inherit"
            style={{ ...styleVariant, position: 'absolute', top: 2, left: 2 }}
            className="rotate"
            onClick={this.handleRotate}
          />
          <ActionDeleteForever
            color="inherit"
            className="deleteTable"
            style={{
              ...styleVariant,
              position: 'absolute',
              bottom: 2,
              left: 2
            }}
            onClick={this.handleDelete}
          />
          <EditAction
            color="inherit"
            className="edit"
            style={{ ...styleVariant, position: 'absolute', top: 2, right: 2 }}
            onClick={this.handleEdit}
          />
        </div>
      ) : null
    let posX = parseInt(table.posX, 10)
    let posY = parseInt(table.posY, 10)
    let grid = 10
    let tableStyle = { ...styles[table.type] }
    let tableWidth = parseInt(styles[table.type].width, 10)
    let tableHeight = parseInt(styles[table.type].height, 10)

    switch (this.props.sizeClass) {
      case 'small':
        posX = posX / 2
        posY = posY / 2
        grid = grid / 2
        tableWidth = tableWidth / 2
        tableHeight = tableHeight / 2
        break
      default:
    }
    if (this.props.isSelectable) {
      tableClass += ' selectTable'
      if (this.props.selectedTable === table.name) tableClass += ' isSelected'
      if (table.currentTransaction === void 0) tableClass += ' disabled'
    }
    tableStyle.width = `${tableWidth}px`
    tableStyle.height = `${tableHeight}px`
    tableStyle.lineHeight = `${parseInt(tableHeight, 10) - 2}px`
    if (table.isVertical) {
      const width = tableStyle.width
      const height = tableStyle.height
      tableStyle.width = height
      tableStyle.height = width
      tableStyle.lineHeight = `${parseInt(width, 10) - 2}px`
    }
    let dragStyle = {}
    if (toggled) {
      dragStyle = this.state.isDragging
        ? { cursor: '-webkit-grabbing' }
        : { cursor: '-webkit-grab' }
    }

    tableStyle = { ...tableStyle, ...dragStyle }
    tableClass = classNames(
      toggled ? classes.tableEdit : classes.table,
      tableStyle
    )
    const content = this.props.isSelectable ? (
      <div
        onClick={this.handleSelect}
        style={{ position: 'absolute', left: posX, top: posY }}>
        <Paper elevation={3} className={tableClass}>
          <div className={tableClass}>{table.num}</div>
        </Paper>
      </div>
    ) : (
      <Draggable
        bounds={{ top: 0, left: 0 }}
        disabled={!toggled}
        position={{ x: posX, y: posY }}
        onStop={this.handleStop}
        onDrag={this.handleDrag}
        grid={[grid, grid]}>
        <Paper
          elevation={3}
          style={tableStyle}
          onMouseEnter={() => this.setState({ isHover: true })}
          onMouseLeave={() => this.setState({ isHover: false })}
          className={tableClass}>
          {this.state.isHover && toggled
            ? tableActions
            : getTableIcon(table.type)}
          <div>{table.num}</div>
        </Paper>
      </Draggable>
    )
    return content
  }
}

TableDraggable.propTypes = propTypes
TableDraggable.defaultProps = {
  disabled: false
}
export default withStyles(stylesClasses)(TableDraggable)



// WEBPACK FOOTER //
// ./src/routes/Admin/Tables/components/TableDraggable.js